import { api } from '@/lib/axios';

// The global ResponseInterceptor (backend/src/common/interceptors/response.interceptor.ts)
// wraps every non-file response as { success, data, timestamp } — unwrap it here,
// same pattern as services/org-id-cards.api.ts.
function unwrap<T>(r: { data: { data?: T } | T }): T {
  const body: any = r.data;
  return (body?.data ?? body) as T;
}

export type TryRole = 'admin' | 'teacher' | 'staff' | 'student' | 'parent';

export interface TryEndpointRequest {
  method: string;
  path: string;
  role: TryRole;
  pathParams?: Record<string, string>;
  query?: Record<string, string>;
  body?: Record<string, unknown>;
}

export interface TryEndpointResult {
  status: number;
  body: unknown;
}

export interface TestDataStatus {
  provisioned: boolean;
  lastResetAt: string | null;
}

/**
 * Backs the "Try Live" feature on /org/mobile-api-docs — every call here
 * runs only against the dedicated synthetic test school
 * (`___api_test_school___`), authenticated as a synthetic identity the
 * backend mints itself. See `backend/src/modules/org-mobile-api-test/`.
 */
export async function tryLiveCall(req: TryEndpointRequest): Promise<TryEndpointResult> {
  const res = await api.post('/org/mobile-api-docs/try', req);
  return unwrap<TryEndpointResult>(res);
}

export async function resetTestData(): Promise<{ schemaName: string; schoolId: string }> {
  const res = await api.post('/org/mobile-api-docs/test-data/reset');
  return unwrap(res);
}

export async function getTestDataStatus(): Promise<TestDataStatus> {
  const res = await api.get('/org/mobile-api-docs/test-data/status');
  return unwrap<TestDataStatus>(res);
}
